/**
 * Iter-229k — Default-switch router for /admin/shifts.
 *
 * Renders the new event-centric Admin Jobs V2 by default. Users can fall
 * back to the legacy shift table by appending `?classic=1` to the URL —
 * the link is also surfaced inside V2 as "Switch to classic table".
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AdminShifts from './AdminShifts';
import AdminJobsV2 from './JobsV2';

const AdminShiftsRouter = () => {
  const [params] = useSearchParams();
  const useClassic = params.get('classic') === '1';
  return useClassic ? <AdminShifts /> : <AdminJobsV2 />;
};

export default AdminShiftsRouter;
